<template>
  <transition name="el-fade-in-linear">
    <div v-show="show" class="reader-mask">
      <div class="reader-content">
        <template v-if="content">
          <div class="home-container">
            <div class="home-content">
              <div class="home-header">
                <img v-if="content.preview !== true" src="@/assets/logo.png" class="logo"/>
              </div>
              <div class="home-body">
                <h2 v-text="$t('view.cover_title')"></h2>
                <h1 v-if="$i18n.locale == 'zh'" v-text="content.factory_name" style="font-size: 45px;"></h1>
                <h1 v-else v-text="content.factory_name_en"></h1>
                <div class="home-buttons">
                  <a v-if="PDFDownloadURL" id="report-btn" target="_blank" :href="PDFDownloadURL">
                    <svg width="23px" height="20px" viewBox="0 0 23 21" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                      <path d="M1.975,12.7 L1.975,19.525 L20.825,19.525 L20.825,12.7 L22.775,12.7 L22.775,21.475 L0.025,21.475 L0.025,12.7 L1.975,12.7 Z M12.375,1 L12.375,13.128 L16.6022453,9.37127591 L17.8977547,10.8287241 L11.4,16.6045061 L4.90224526,10.8287241 L6.19775474,9.37127591 L10.425,13.13 L10.425,1 L12.375,1 Z"></path>
                    </svg>
                    {{$t('view.report')}}
                  </a>
                  <a id="overview-btn" @click="handleStart" :loading="loading">
                    <i v-if="loading" class="loading"></i>
                    <template v-else><span class="icon"><i class="el-icon-caret-right"/></span>{{$t('view.overview')}}</template>
                  </a>
                </div>
              </div>
              <div class="home-footer">
                <div class="info">
                  <img src="@/assets/check.png">
                  {{$t('base.audit_date')}}: {{ content.audit_date }}
                </div>
                <img src="@/assets/footer.png" class="footer-bg">
              </div>
            </div>
          </div>
          <div class="line-container">
            <div class="line-left"/>
            <div class="line-right"/>
          </div>
          <div class="bg-container">
            <img src="@/assets/decoration.png" class="decoration">
            <img src="@/assets/bg.png" class="bg">
          </div>
        </template>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'Cover',
  props: {
    content: Object,
    loading: {
      type: Boolean,
      default: false
    },
    PDFDownloadURL: String
  },
  data() {
    return {
      show: true
    }
  },
  methods: {
    handleStart() {
      this.$emit('start');
      this.show = false;
    }
  }
}
</script>